export const toggleNavBarItems = item => ({
  type: 'TOGGLE_NAVBAR_ITEMS',
  payload: item
})

